<template>
  <div
    v-if="!isLoading"
    class="accrs_list"
  >
    <re-tooltip
      v-for="(accr, i) in accrs"
      :key="user + '_accr_' + i"
      :label="accr.accreditation_number || 'No number'"
      hide-tooltip-icon
    >
      <span>
        {{ accr.institution }}
        <re-badge
          v-if="editable"
          color="primary"
          @click="showDelete(accr)"
        >
          x
        </re-badge>
      </span>
    </re-tooltip>
    <re-badge
      v-if="editable"
      color="accent"
      class="add_accr-bttn"
      @click="showNewAccr"
    >
      +
    </re-badge>
    <re-dialog v-model="modalShown">
      <div v-if="isDeleting">
        <h3>Are you sure you want to delete this accreditation number?</h3>
        <p>This action cannot be reverted.</p>
      </div>
      <div v-if="isCreating">
        <h3>{{ $t('admin_panel.user_mgmt.new_accreditation') }}</h3>
        <re-input
          v-model="newAccrInstitution"
          type="text"
          :placeholder="$t('admin_panel.user_mgmt.accreditation_institution')"
        />
        <re-input
          v-model="newAccrNr"
          type="text"
          :placeholder="$t('admin_panel.user_mgmt.accreditation_number')"
        />
      </div>
      <template #actions>
        <re-button
          v-if="isDeleting"
          color="negative"
          label="Delete"
          @click="removeAccr"
        />
        <re-button
          v-else
          color="main"
          :disable="isNewAccrDisabled"
          :label="$t('admin_panel.user_mgmt.add_accreditation')"
          @click="createNewAccr"
        />
        <re-button
          label="Cancel"
          @click="cancelModal"
        />
      </template>
    </re-dialog>
  </div>
  <q-skeleton
    v-else
    width="100%"
    height="100%"
  />
</template>
<script>
import axios from '@/plugins/axios.js'
import utils from '@/plugins/utils'
export default {
  name: 'AdminAccreditations',
  props: {
    user: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: true,
    accrs: null,
    newAccrInstitution: '',
    newAccrNr: '',
    modalShown: false,
    isCreating: false,
    isDeleting: false,
    deletingAccr: null,
  }),
  computed: {
    isNewAccrDisabled() {
      return utils.isEmptyStr(this.newAccrInstitution)
    },
  },
  watch: {
    isCreating(val) {
      this.newAccrInstitution = ''
      this.newAccrNr = ''
      this.modalShown = val
    },
    isDeleting(val) {
      this.modalShown = val
    },
  },
  mounted() {
    this.loadAccrs()
  },
  methods: {
    loadAccrs() {
      if (!this.user) {
        this.isLoading = false
        return
      }

      const url = utils.urlJoin(this.$config.AUTH_API_URL, ['accreditations', 'user', this.user])

      axios
        .get(url)
        .then((res) => {
          this.accrs = res.data
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          return
        })
    },
    cancelModal() {
      this.isCreating = false
      this.isDeleting = false
    },
    showNewAccr() {
      this.isCreating = true
    },
    showDelete(accr) {
      this.deletingAccr = accr
      this.isDeleting = true
    },
    removeAccr() {
      this.isLoading = true
      const url = utils.urlJoin(this.$config.AUTH_API_URL, ['accreditations', this.deletingAccr.id])

      axios.delete(url).then(() => {
        this.loadAccrs()
        this.isDeleting = false
        this.deletingAccr = null
      })
    },
    resetNewAccr() {
      this.newAccrInstitution = ''
      this.newAccrNr = ''
    },
    createNewAccr() {
      const url = utils.urlJoin(this.$config.AUTH_API_URL, ['accreditations', 'user', this.user])

      axios
        .post(url, {
          institution: this.newAccrInstitution,
          accreditation_number: this.newAccrNr,
        })
        .then(() => {
          this.loadAccrs()
          this.isCreating = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.accr-modal {
  padding: 1rem;
  background: $base;
  z-index: 99;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  box-shadow: $re-shadow-light;
  min-width: 250px;
  max-width: 400px;

  h3 {
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }

  .modal-actions {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    margin-top: 1rem;
  }
}

.accrs_list {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 0.3rem;
}

.add_accr-tooltip {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  width: 150px;
}
</style>
